/**
 * @author yan st
 * @date 2022-08-30 13:51
 * @Description:
 */

export const homeRouter = [
  {
    path: "",
    redirect: "index",
  },
  {
    path: "index",
    meta: {
      title: "我的申报",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/index"),
  },
  // {
  //   path: "project_list/index",
  //   meta: {
  //     title: "月报填写",
  //     needLogin: true, // 是否需要登录才能访问
  //   },
  //   component: () => import("../views/orghome/page/project_list/index"),
  // },
  // {
  //   path: "project_list/detail",
  //   meta: {
  //     title: "月报填写",
  //     needLogin: true, // 是否需要登录才能访问
  //   },
  //   component: () => import("../views/orghome/page/project_list/detail"),
  // },
  {
    path: "project_list/index",
    meta: {
      title: "中期评审资料上传",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/project_list/index"),
  },
  {
    path: "project_list/detail",
    meta: {
      title: "中期评审资料上传",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/project_list/detail"),
  },
  {
    path: "project_list/upload_file",
    meta: {
      title: "中期评审资料上传-详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/project_list/upload_file"),
  },
  {
    path: "end_project_list/index",
    meta: {
      title: "结项评审资料上传",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/end_project_list/index"),
  },
  {
    path: "end_project_list/detail",
    meta: {
      title: "结项评审资料上传",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/end_project_list/detail"),
  },
  {
    path: "end_project_list/upload_file",
    meta: {
      title: "结项评审资料上传-详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () =>
      import("../views/orghome/page/end_project_list/upload_file"),
  },
  {
    path: "supply_project_list/index",
    meta: {
      title: "结项评审资料上传（补充）",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/supply_project_list/index"),
  },
  {
    path: "supply_project_list/detail",
    meta: {
      title: "结项评审资料上传（补充）",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/supply_project_list/detail"),
  },
  {
    path: "supply_project_list/upload_file",
    meta: {
      title: "结项评审资料上传（补充）-详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () =>
      import("../views/orghome/page/supply_project_list/upload_file"),
  },
  {
    path: "project",
    meta: {
      title: "我的申报（待补充资料）",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/project/index"),
  },
  {
    path: "loglist",
    meta: {
      title: "日志列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/loglist"),
  },
  {
    path: "pass",
    meta: {
      title: "修改密码",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/orghome/page/pass"),
  },
];

export default homeRouter;
